import React from 'react';
import { useState } from 'react';
import styled from 'styled-components/macro';
import { Dropdown, NewModal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { accessTypeOptions } from 'lib/const/AccessRole';

const Content = styled.div`
  width: 600px;
  margin-top: 24px;
`;

const SubmitButtonWrapper = styled.div`
  text-align: right;
  margin-top: 32px;
`;

type Props = {
  handleModalClose: (shouldRefresh?: boolean) => void;
  selectedUsers: number[];
  isLoading: boolean;
  onPrimaryButtonClick: (userIds: number[], access: number) => Promise<void>;
  commonUserType?: number;
};

export const ChangeUsersAccessRoleModal = ({
  handleModalClose,
  selectedUsers,
  onPrimaryButtonClick,
  commonUserType,
  isLoading,
}: Props) => {
  const [accessRole, setAccessRole] = useState<number>(commonUserType || 0);
  const headerText = `Edit User Type for ${
    selectedUsers.length
  } user${selectedUsers.length > 1 ? 's' : ''}!`;

  return (
    <NewModal
      headerText={headerText}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => {
        handleModalClose();
      }}
      headerMargin='0 0 0 0'
      style={{
        content: {
          padding: '24px 24px 16px 24px',
          minWidth: 'auto',
          paddingLeft: '32px',
        },
      }}
    >
      <Content>
        <Dropdown
          menuPortalTarget={document.body}
          menuPosition='fixed'
          menuPlacement={'bottom'}
          creatable={false}
          options={accessTypeOptions}
          placeholder='Select User Type'
          value={accessTypeOptions.find(o => {
            return o.value === accessRole;
          })}
          onChange={option => {
            setAccessRole(option.value);
          }}
          isLoading={isLoading}
          className='option-container'
        />
        <SubmitButtonWrapper>
          <Button
            text={'Save Changes'}
            onClick={() => {
              onPrimaryButtonClick(selectedUsers, accessRole).then(() => {
                handleModalClose(true);
              });
            }}
            disabled={isLoading}
          />
        </SubmitButtonWrapper>
      </Content>
    </NewModal>
  );
};
